import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface AlertData {
  headline: string,
  body: string,
  btnCancel: string,
  btnSubmit: string
}

@Component({
  selector: 'kion-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {

  @Input() data: AlertData;

  constructor(private dialog: NgbActiveModal) { }

  submit(hasAgreed: boolean) {
    this.dialog.close(hasAgreed);
  }
}
